<template>
  <div v-if="board">
    <v-sheet class="ma-5 pa-2 rounded text-center row align-items-center justify-content-center">
      <div class="my-auto">
        <v-tooltip color="error" top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon @click="updateBoardData" :loading="updateLoading" color="primary">
              <v-icon >mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>بروزرسانی اطلاعات</span>
        </v-tooltip>
      </div>
      <h1 class="mx-auto text-center my-auto">برد '{{ board.name }}'</h1>
      <BackButton class="my-auto" @click="closeDetailView" />
    </v-sheet>

    <v-card class="elevation-0">
      <v-card-text v-if="loading" class="text-center">
        <v-progress-circular :size="100" :width="7" color="#d20003" indeterminate />
      </v-card-text>

      <v-card-text v-else>
        <DeviceTable
            :relays="board.relays"
            :loading="loading"
            :updateLoading="updateLoading"
            @confirmStatus="openConfirmStatusDialog"
        />
      </v-card-text>
    </v-card>

    <StatusConfirmationDialog
        :dialog="confirmStatus.dialog"
        :device="confirmStatus.device"
        :loading="confirmStatus.loading"
        @cancel="closeConfirmDialog"
        @confirm="confirmDeviceStatus"
    />
  </div>

  <div v-else class="w-[100%] text-center">
    <v-progress-circular
        :size="100"
        class="mx-auto"
        :width="7"
        color="#d20003"
        indeterminate
    />
  </div>
</template>

<script>
import axios from "axios";
import BackButton from "@/components/BackButton.vue";
import DeviceTable from "@/components/admin/devices_control/DeviceTable.vue";
import StatusConfirmationDialog from "@/components/admin/devices_control/StatusConfirmationDialog.vue";

export default {
  name: "BoardDetail",
  props: ["detail"],
  components: {
    BackButton,
    DeviceTable,
    StatusConfirmationDialog,
  },
  data() {
    return {
      key: localStorage.getItem("key"),
      loading: false,
      updateLoading: false,
      board: null,
      confirmStatus: {
        dialog: false,
        loading: false,
        device: {},
      },
      refreshInterval: null,
      old_changed: [],
    };
  },
  watch: {
    detail: {
      immediate: true,
      handler() {
        if (this.detail.en) {
          this.fetchBoardData();
          this.startBackgroundRefresh();
        } else {
          this.stopBackgroundRefresh();
        }
      },
    },
  },
  methods: {
    closeDetailView() {
      this.detail.en = false;
    },
    async updateBoardData() {
      await this.fetchBoardData();
    },
    async fetchBoardData() {
      this.loading = true;
      try {
        console.log("Fetching board data...");
        const {data} = await axios.get(
            `${this.BACKEND_LINK}/api/devices-data/detail/${this.detail.board_id}`,
            {headers: {Authorization: `Token ${this.key}`}, timeout: 5000}
        );
        this.board = {...data}; // Ensure reactivity by replacing the object
        await this.fetchAllBoardData();
      } catch (error) {
        console.error("Error fetching board data:", error);
      } finally {
        this.loading = false;
      }
    },
    async fetchAllBoardData() {
      this.updateLoading = true;
      try {
        console.log("Fetching board data...");
        const {data} = await axios.get(
            `${this.BACKEND_LINK}/api/devices-data/device/all/?pk=${this.detail.board_id}`,
            {headers: {Authorization: `Token ${this.key}`}, timeout: 5000}
        );
        for(let i = 0; i < this.board.relays.length; i++) {
          if(this.board.relays[i]) {
            this.board.relays[i]['data'] = data[i]['data']
            this.board.relays[i]['set'] = data[i]['set']
          }
        }
        // await this.refreshData();
      } catch (error) {
        console.error("Error fetching board data:", error);
      } finally {
        this.updateLoading = false;
      }
    },



    startBackgroundRefresh() {
      if (this.refreshInterval) clearInterval(this.refreshInterval);
      console.log("Starting background refresh...");
      this.refreshInterval = setInterval(() => {
        console.log("Triggering refreshData...");
        this.fetchAllBoardData();
      }, 5000);
    },
    stopBackgroundRefresh() {
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
        this.refreshInterval = null;
      }
    },
    // Existing methods remain the same...
    async changeDeviceStatus() {
      const {device} = this.confirmStatus;
      const payload = {
        board_code: this.board.code,
        field_name: device.value,
        status: !!device.set._value,
      };
      try {
        const {data} = await axios.put(`${this.BACKEND_LINK}/api/devices-data/device/status/`, payload,
            {headers: {Authorization: `Token ${this.key}`}}
        );
        this.$snotify.warning(data.msg);
        this.resetConfirmStatus();
        this.old_changed.push({
          field_name: device.value,
          status: !!device.set._value,
        })
        setTimeout( () => {
          this.fetchAllBoardData(device)
        }, 3000)
      } catch (error) {
        this.$snotify.error("خطا در ارسال اطلاعات", `کد ${error.response?.code}`);
        console.error("Error changing device status:", error);
      } finally {
        this.confirmStatus.loading = false;
      }
    },
    openConfirmStatusDialog(device) {
      this.stopBackgroundRefresh();
      this.confirmStatus.dialog = true;
      this.confirmStatus.device = device;
    },
    confirmDeviceStatus() {
      this.confirmStatus.loading = true;
      this.changeDeviceStatus();
      this.startBackgroundRefresh();
    },
    closeConfirmDialog() {
      this.confirmStatus.device.set['_value'] = !this.confirmStatus.device.set['_value']
      this.confirmStatus.dialog = false;
      this.updateBoardData();
      this.startBackgroundRefresh();
    },
    resetConfirmStatus() {
      this.confirmStatus.dialog = false;
      this.confirmStatus.device = {};
      this.confirmStatus.loading = false;
    },
  },
  beforeDestroy() {
    this.stopBackgroundRefresh();
  },
};
</script>

<style scoped>
/* Keep necessary styling */
</style>
